import React from "react";
import PropTypes from "prop-types";

import SuggestItem from "../suggest-item";

const RecentSuggestItem = ({ onSelect, suggest }) => {
  const { label, type } = suggest;

  const clickHandler = () => {
    onSelect(suggest);
  };

  return (
    <li>
      <SuggestItem description={label} onClick={clickHandler} type={type} />
    </li>
  );
};

RecentSuggestItem.propTypes = {
  onSelect: PropTypes.func.isRequired,
  suggest: PropTypes.shape({
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
};

export default RecentSuggestItem;
